import React, { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { 
  FaQrcode, 
  FaExternalLinkAlt, 
  FaFilePdf, 
  FaImages,
  FaCalendarAlt,
  FaNotesMedical
} from "react-icons/fa";
import { QRCode, Collapse } from "antd";
import { cdhaService } from "../../services/cdhaService";
import Loading from "../common/Loading/Loading";
import styles from "./ViewCdha.module.css";

export const PACSViewerSection = ({ pacsUrl = null }) => {
    if (!pacsUrl) return null;

    return (
        <div className={styles.pacsViewer}>
            <div className={styles.pacsHeader}>
                <h3 className={styles.pacsTitle}>Truy cập ảnh chẩn đoán</h3>
            </div>
            <div className={styles.pacsContent}>
                <div className={styles.pacsGrid}>
                    <div className={styles.pacsLeft}>
                        <p className={styles.pacsDescription}>
                            Kết quả chẩn đoán hình ảnh đã được lưu trữ trực tuyến. Quý khách có
                            thể xem chi tiết qua liên kết dưới đây hoặc quét mã QR bằng điện thoại.
                        </p>
                        <a
                            href={pacsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.pacsLink}
                        >
                            <FaExternalLinkAlt />
                            Xem ảnh PACS
                        </a>
                    </div>
                    <div className={styles.pacsRight}>
                        <div className={styles.qrSection}>
                            <div className={styles.qrCode}>
                                <QRCode
                                    value={'http://samson.pacs.medichospital.com:9001/viewer?StudyInstanceUIDs=2.25.33342632310399102710232185718725839647'}
                                    size={140}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    logoImage="/img/medic-sm.png"
                                    logoWidth={30}
                                    quietZone={10}
                                />
                            </div>
                            <div className={styles.qrText}>
                                <FaQrcode />
                                Quét QR để mở trên điện thoại
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ViewCdha = ({ externId }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await cdhaService.getCdhaById(externId);
                setData(result);
            } catch (error) {
                console.error("Lỗi fetch:", error);
            } finally {
                setLoading(false);
            }
        };

        if (externId) {
            fetchData();
        } else {
            setLoading(false);
        }
    }, [externId]);

    if (loading) {
        return <Loading tip="Đang tải dữ liệu..." fullScreen={false} />;
    }

    if (!data) {
        return (
            <div className={styles.errorContainer}>
                <h3 className={styles.errorTitle}>Không tìm thấy dữ liệu</h3>
            </div>
        );
    }

    const {
        ngayKQ,
        moTa,
        ketLuan,
        typeCls,
        urls = [],
        pacsUrl = "",
    } = data;

    const galleryItems = cdhaService.formatGalleryItems(urls);

    const collapseItems = [];

    if (moTa) {
        collapseItems.push({
            key: "1",
            label: <span><FaNotesMedical className={styles.panelIcon} /> Mô tả chi tiết</span>,
            children: <div className={styles.panelContent}>{moTa}</div>
        });
    }

    collapseItems.push({
        key: "2",
        label: <span><FaNotesMedical className={styles.panelIcon} /> {cdhaService.getPanelTitle(typeCls)}</span>,
        children: <div className={styles.panelContent}>{ketLuan}</div>
    });

    return (
        <>
            {/* Service Information */}
            <div className={styles.serviceCard}>
                <div className={styles.serviceInfo}>
                    <div className={styles.infoRow}>
                        <span className={styles.infoLabel}>
                            <FaCalendarAlt className={styles.infoIcon} />
                            Ngày có kết quả:
                        </span>
                        <span className={styles.resultDateBadge}>{ngayKQ}</span>
                    </div>
                </div>
                
                <div className={styles.collapseContent}>
                    <Collapse
                        items={collapseItems}
                        defaultActiveKey={["2"]}
                        ghost
                        expandIconPosition="end"
                    />
                </div>
            </div>

            {/* Image Gallery */}
            {galleryItems.length > 0 && (
                <div className={styles.galleryCard}>
                    <h3 className={styles.galleryTitle}>
                        <FaImages className={styles.galleryIcon} />
                        Hình ảnh liên quan
                    </h3>
                    <div className={styles.galleryContainer}>
                        <ReactImageGallery
                            items={galleryItems.map((item) => {
                                if (item.isPdf) {
                                    return {
                                        original: item.original,
                                        thumbnail: item.thumbnail,
                                        description: item.description,
                                        renderItem: () => (
                                            <div
                                                className={styles.pdfPlaceholder}
                                                onClick={() => window.open(item.pdfUrl, "_blank")}
                                            >
                                                <FaFilePdf className={styles.pdfIcon} />
                                                <span className={styles.pdfText}>📄 Nhấn để xem thông tin chi tiết</span>
                                            </div>
                                        )
                                    };
                                } else {
                                    return {
                                        original: item.original,
                                        thumbnail: item.thumbnail,
                                        description: item.description
                                    };
                                }
                            })}
                            showThumbnails={urls.length > 1}
                            showPlayButton={false}
                            showFullscreenButton
                            lazyLoad
                        />
                    </div>
                </div>
            )}

            {/* PACS Viewer */}
            <PACSViewerSection   pacsUrl={pacsUrl} />
        </>
    );
};

export default ViewCdha;
